import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { useQuasar } from 'quasar';

export interface Props extends PropValue<null | string> {
  readonly?: boolean;
  minHeight?: string;
}

export default /*@__PURE__*/_defineComponent({
  ...{ name: 'SEditor' },
  __name: 'SEditor',
  props: {
    readonly: { type: Boolean, default: false },
    minHeight: { default: '128px' },
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const toolbar: Array<any> = [
  [
    {
      label: 'Выравнивание',
      icon: 'format_align_left',
      fixedLabel: true,
      list: 'only-icons',
      options: ['left', 'center', 'right', 'justify'],
    },
  ],
  ['left', 'center', 'right', 'justify'],
  ['bold', 'italic', 'underline', 'subscript', 'superscript'],
  [
    {
      label: 'Форматирование',
      icon: 'text_format',
      list: 'no-icons',
      options: ['size-1', 'size-2', 'size-3', 'size-4'],
    },
    {
      label: 'Шрифт по умолчанию',
      icon: 'font_download',
      fixedIcon: true,
      list: 'no-icons',
      options: ['default_font', 'intro', 'roboto'],
    },
  ],
  ['quote', 'unordered', 'ordered', 'outdent', 'indent'],
  ['undo', 'redo', 'removeFormat'],
  ['viewsource'],
];

const fonts: Record<string, string> = {
  intro: 'Intro',
  roboto: 'Roboto',
};

const props = __props;
const emit = __emit;
const { innerValue, emitValue } = useValue(props, emit, {
  transform: (value) => value ?? '',
});
const $q = useQuasar();

return (_ctx: any,_cache: any) => {
  const _component_q_editor = _resolveComponent("q-editor")!

  return (_openBlock(), _createBlock(_component_q_editor, {
    ref: "content",
    modelValue: _unref(innerValue),
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
      _unref(emitValue)
    ],
    class: "s-editor",
    "min-height": _ctx.minHeight,
    height: "100%",
    dense: _unref($q).screen.lt.md,
    toolbar: toolbar,
    fonts: fonts,
    readonly: _ctx.readonly
  }, null, 8, ["modelValue", "min-height", "dense", "readonly", "onUpdate:modelValue"]))
}
}

})